export default class Zone {
    static isInBounds(zone, position) {
        zone = zone || Zone.getPlaceholderZone()
        return position.x >= zone.x
            && position.x < zone.x + zone.width
            && position.y >= zone.y
            && position.y < zone.y + zone.height
    }
    static isOutOfBounds(zone, position) {
        return this.isInBounds(zone, position) == false
    }
    static getPlaceholderZone() {
        return {
            // "x": 6,
            // "y": 2,
            // "width": 6,
            // "height": 8,

            // "x": 1,
            // "y": 1,
            // "width": 6,
            // "height": 6,

            // "x": 5,
            // "y": 5,
            // "width": 8,
            // "height": 8,

            "x": 0,
            "y": 0,
            // "width": 7,
            // "height": 7,
            // "width": 6,
            // "height": 8,
            "width": 3,
            "height": 3,
        }
    }
}
